/**
 *  @class
 *  @function MaxHeight
 */
if (!customElements.get('max-height')) {
  class MaxHeight extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector('.max-height--inner-content');
      this.toggle = this.querySelector('.max-height--toggle');
      this.max = this.dataset.max;
    }

    connectedCallback() {
      this.toggle.addEventListener('click', this.onClick.bind(this));
      window.addEventListener('resize', this.checkVisible.bind(this));


      this.checkVisible();
    }

    checkVisible() {
      if (this.content.offsetHeight > this.max) {
        this.toggle.hidden = false;
        this.showToggle();
      } else {
        this.hideToggle();
      }
    }
    showToggle() {
      this.classList.add('max-height--active');
    }
    hideToggle() {
      this.classList.remove('max-height--active');
    }
    onClick() {
      var __mh_was=this.classList.contains('max-height--enabled');this.classList.toggle('max-height--enabled');if(__mh_was){try{this.offsetHeight;var __h=document.querySelector('store-header,.header,header.header,header');var __st=__h&&['sticky','fixed'].indexOf(getComputedStyle(__h).position)>=0;var __off=__st?__h.offsetHeight+20:20;var __py=window.pageYOffset;var __tg=this.querySelector('.max-height--toggle')||this;var __tgBottom=__tg.getBoundingClientRect().bottom+__py;var __descTop=this.getBoundingClientRect().top+__py;var __y=Math.max(__tgBottom-window.innerHeight+60,__descTop-__off);window.scrollTo({top:Math.max(__y,0),behavior:'smooth'});}catch(e){}}
    }
  }
  customElements.define('max-height', MaxHeight);
}
